<template>
  <v-card color="grey lighten-3" :elevation="0">
    <v-card-title primary-title>
      <div>
        <h3 class="title mt-0 mb-3">{{ $t('asset_wise.land_status.title') }}</h3>
        <p class="title ma-0">{{ $t('Total2') }}: {{ total | numberFormat }}</p>
      </div>
    </v-card-title>
    <v-card-text>
      <div
        :style="{
          display: 'grid',
          gridTemplateColumns: $vuetify.breakpoint.xsOnly
            ? '1fr'
            : $vuetify.breakpoint.smAndDown
            ? 'repeat(2, 1fr)'
            : $vuetify.breakpoint.mdAndDown
            ? 'repeat(3, 1fr)'
            : 'repeat(5, 1fr)',
          gap: '8px'
        }"
      >
        <v-card>
          <v-card-title primary-title>
            {{ $t('asset_wise.land_status.undecided') }}
          </v-card-title>
          <v-card-text class="title">
            {{ undecided | numberFormat }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title primary-title>
            {{ $t('asset_wise.land_status.considering') }}
          </v-card-title>
          <v-card-text class="title">
            {{ considering | numberFormat }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title primary-title>
            {{ $t('asset_wise.land_status.stage1') }}
          </v-card-title>
          <v-card-text class="title">
            {{ stage1 | numberFormat }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title primary-title>
            {{ $t('asset_wise.land_status.stage2') }}
          </v-card-title>
          <v-card-text class="title">
            {{ stage2 | numberFormat }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title primary-title>
            {{ $t('asset_wise.land_status.deposit') }}
          </v-card-title>
          <v-card-text class="title">
            {{ deposit | numberFormat }}
          </v-card-text>
        </v-card>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    undecided: {
      type: Number,
      default: 0
    },
    considering: {
      type: Number,
      default: 0
    },
    stage1: {
      type: Number,
      default: 0
    },
    stage2: {
      type: Number,
      default: 0
    },
    deposit: {
      type: Number,
      default: 0
    }
  },
  computed: {
    total() {
      return Object.values(this.$props).reduce((acc, value) => acc + value, 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/LandSale/StatusInfo.vue